import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "16,2 22,2 22,8 ", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "22", y1: "2", x2: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22,12c0,5.5-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "ArrowUpRightFromCircle";
const ArrowUpRightFromCircle = memo(themed(Icon));
export {
  ArrowUpRightFromCircle
};
//# sourceMappingURL=arrow-up-right-from-circle.js.map
